import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dark: true
  },
  mutations: {
    TOGGLE_DARK_MODE (state) {
      state.dark = !state.dark
    }
  },
  actions: {
  },
  modules: {
  }
})
